import { isPlatformBrowser } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UserAgentService {
  private platform = inject(PLATFORM_ID);

  userAgent: string;

  constructor() {
    if (isPlatformBrowser(this.platform)) {
      this.userAgent = navigator.userAgent;
    }
  }

  isMobileDevice(): boolean {
    const regexs = [/(Android)(.+)(Mobile)/i, /BlackBerry/i, /iPhone|iPod/i, /Opera Mini/i, /IEMobile/i];
    return regexs.some((b) => this.userAgent.match(b));
  }

  isTabletDevice(): boolean {
    const regex =
      /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(.*(IT|AT))))/i;
    return regex.test(this.userAgent);
  }

  isDesktopDevice(): boolean {
    return !this.isMobileDevice() && !this.isTabletDevice();
  }

  isAndroid(): boolean {
    return this.isMobileDevice() && /android/i.test(this.userAgent);
  }

  isIos(): boolean {
    return (
      this.isMobileDevice() &&
      /iPad|iPhone|iPod/.test(this.userAgent) &&
      !(window as Window & { MSStream?: unknown }).MSStream
    );
  }

  getUserBroswer(): string {
    // NOSONAR
    let match: RegExpMatchArray = null;

    if (/chrome|crios|crmo/i.test(this.userAgent) && !/edg|edge|opera|opr/i.test(this.userAgent)) {
      match = this.userAgent.match(/(?:chrome|crios|crmo)\/(\d{1,4})/i);
      return match ? `Chrome ${match[1]}` : 'Chrome';
    }

    if (/edg\/\d+/i.test(this.userAgent)) {
      match = this.userAgent.match(/(?:edg)\/(\d{1,4})/i);
      return match ? `Edge (Chromium) ${match[1]}` : 'Edge (Chromium)';
    }

    if (/edge\/\d+/i.test(this.userAgent)) {
      match = this.userAgent.match(/(?:edge)\/(\d{1,4})/i);
      return match ? `Edge (Legacy) ${match[1]}` : 'Edge (Legacy)';
    }

    if (/firefox|fxios/i.test(this.userAgent)) {
      match = this.userAgent.match(/(?:firefox|fxios)\/(\d{1,4})/i);
      return match ? `Firefox ${match[1]}` : 'Firefox';
    }

    if (/safari/i.test(this.userAgent) && !/chrome|crios|crmo/i.test(this.userAgent)) {
      match = this.userAgent.match(/version\/(\d{1,4})/i);
      return match ? `Safari ${match[1]}` : 'Safari';
    }

    if (/opr|opera/i.test(this.userAgent)) {
      match = this.userAgent.match(/(?:opr|opera)\/(\d{1,4})/i);
      return match ? `Opera ${match[1]}` : 'Opera';
    }

    if (/msie|trident/i.test(this.userAgent)) {
      match = this.userAgent.match(/(?:msie\s|rv:)(\d{1,4})/i);
      return match ? `IE ${match[1]}` : 'IE';
    }

    return 'other';
  }
}
